import { Wrapper } from "shared/ui/Wrapper/Wrapper";
import { classNames } from "shared/lib/classNames/classNames";
import { Title, TitleSize } from "shared/ui/Title/Title";
import { Text, TextSize } from "shared/ui/Text/Text";
import { PurchaseCard } from "widgets/PurchaseCard";
import { ServiceCard } from "widgets/ServiceCard";
import { useEffect, useState } from "react";
import { useApi } from "app/api/APIProvider";
import { useSelector } from "react-redux";
import {
    getProductsInfo,
    getSpecialProducts,
} from "features/Services/modal/selectors/getServicesData/getServicesData";
import { Tabs } from "shared/ui/Tabs";
import { TabsTheme } from "shared/ui/Tabs/Tabs";
import { APIProductTypes, APIUser } from "app/api/APITypes";
import { AssistantOverlay } from "features/AssistantOverlay";
import { AppLink } from "shared/ui/AppLink/AppLink";
import { Button, ButtonTheme } from "shared/ui/Button/Button";
import { PageLoader } from "shared/ui/PageLoader/PageLoader";
import plugImage from "shared/assets/img/pages/card-plug.png";
import { images } from "../api/financeImages";
import PlayIcon from "shared/assets/icons/playIcon.svg";
import cls from "./FinancePage.module.scss";

interface IProduct {
    attributes: [];
    description: number;
    id: number;
    max_amount: number;
    name: string;
    paragraph_1: string;
    paragraph_2: string;
    price: number;
    required_level: number;
    type: string;
    unique_key: string;
}

interface IProducts {
    section: string;
    products: IProduct[];
}

export const FinancePage = () => {
    const api = useApi();
    const user = api.User;
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [isProductsSection, setIsProductsSection] = useState<boolean>(false);
    const products = useSelector(getSpecialProducts);
    const productsInfo = useSelector(getProductsInfo);

    const shopTabs: { name: string; filter?: APIProductTypes }[] = [
        { name: "Все" },
        { name: "Полисы", filter: "tech" },
        { name: "Инвестиции", filter: "bank" },
    ];

    const messagesForAssistant: { [key: number]: string } = {
        1: "Тут ты сможешь оформить банковские продукты, которые помогут сохранить и защитить твои деньги. Страховка пригодится, если произойдут неприятности. А инвестиции помогут приумножить  доход.",
        2: "Теперь тебе доступны вклады с повышенным процентом, кредиты, инвестиции и страхование. Подробнее с каждым продуктом можно ознакомиться, кликнув на его название.",
        3: "Например, накопительное страхование жизни (НСЖ) поможет не только накопить на мечту, но и защитит тебя и твои сбережения!",
        4: "Долевое страхование жизни - страхование с инвестиционным доходом, при котором можно инвестировать капитал в потенциально доходные активы, а также обеспечить страховую защиту и позаботиться о финансовом благополучии. Походит для клиентов, которые хотят воспользоваться ростом фондового рынка без риска потери основных вложенных сумм.",
    };

    const setActiveTabButton = (
        index: number,
        filter?: APIProductTypes,
        activeTab?: any
    ) => {
        setActiveTabIndex(activeTab);
    };

    useEffect(() => {
        const showProductsSection = sessionStorage.getItem(
            "showProductsSection"
        );

        if (showProductsSection === "Показать") {
            setIsProductsSection(true);
        } else {
            setIsProductsSection(false);
        }
    }, []);

    return (
        <div className={cls.page}>
            <Wrapper className={cls.mainWrapper}>
                <main className={cls.main}>
                    <AssistantOverlay
                        switcher={isProductsSection}
                        message={messagesForAssistant[user.level]}
                        section="showProductsSection"
                    ></AssistantOverlay>
                    <Title
                        className={cls.title}
                        color="#353850"
                        size={TitleSize.title_36}
                    >
                        Финансовые инструменты
                    </Title>
                    <div className={cls.tabsButtonWrapper}>
                        <Tabs
                            shopTabs={shopTabs}
                            type={TabsTheme.V1}
                            theme="shop"
                            cb={setActiveTabButton}
                        />
                    </div>
                    <div className={cls.contentWrapper}>
                        {activeTabIndex === 0 ? (
                            products.map(
                                (
                                    { section, products }: IProducts,
                                    index: number
                                ) => {
                                    return (
                                        <div
                                            className={cls.contentSection}
                                            key={`${section} ${index}`}
                                        >
                                            <Title
                                                className={cls.sectionTitle}
                                                color="#353850"
                                                size={TitleSize.title_20}
                                            >
                                                {section}
                                            </Title>
                                            <div className={cls.cardsWrapper}>
                                                {products.map(
                                                    (item: any, index) => {
                                                        return (
                                                            <div
                                                                className={
                                                                    cls.goodCard
                                                                }
                                                                key={index}
                                                            >
                                                                <div
                                                                    className={classNames(
                                                                        "",
                                                                        {
                                                                            //@ts-ignore
                                                                            [cls.disableCard]:
                                                                                item.required_level >
                                                                                    1 &&
                                                                                user.level <
                                                                                    item.required_level,
                                                                        }
                                                                    )}
                                                                >
                                                                    <ServiceCard
                                                                        name={
                                                                            item.name
                                                                        }
                                                                        img={
                                                                            images[
                                                                                item
                                                                                    .unique_key
                                                                            ]
                                                                        }
                                                                        description={
                                                                            item.description
                                                                        }
                                                                        uniqueKey={
                                                                            item.unique_key
                                                                        }
                                                                        isIssued={
                                                                            productsInfo[
                                                                                item
                                                                                    .unique_key
                                                                            ]
                                                                        }
                                                                    />
                                                                </div>
                                                                <div
                                                                    className={classNames(
                                                                        cls.requiredLevelTablet,
                                                                        {
                                                                            //@ts-ignore
                                                                            [cls.visibleTablet]:
                                                                                item.required_level >
                                                                                    1 &&
                                                                                user.level <
                                                                                    item.required_level,
                                                                        }
                                                                    )}
                                                                >
                                                                    <Text
                                                                        className={
                                                                            cls.cardTitle
                                                                        }
                                                                        color="#353850"
                                                                        size={
                                                                            TextSize.text_16
                                                                        }
                                                                    >
                                                                        {`Откроется на ${item.required_level} уровне`}
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        </div>
                                    );
                                }
                            )
                        ) : (
                            //@ts-ignore
                            <div
                                className={cls.contentSection}
                                //@ts-ignore
                                key={`${products[activeTabIndex].section}`}
                            >
                                <Title
                                    className={cls.sectionTitle}
                                    color="#353850"
                                    size={TitleSize.title_20}
                                >
                                    {
                                        //@ts-ignore
                                        products[activeTabIndex].section
                                    }
                                </Title>
                                <div className={cls.cardsWrapper}>
                                    {
                                        //@ts-ignore
                                        products[activeTabIndex].products.map(
                                            (item: any, index: number) => {
                                                return (
                                                    <div
                                                        className={cls.goodCard}
                                                        key={index}
                                                    >
                                                        <div
                                                            className={classNames(
                                                                "",
                                                                {
                                                                    //@ts-ignore
                                                                    [cls.disableCard]:
                                                                        item.required_level >
                                                                            1 &&
                                                                        user.level <
                                                                            item.required_level,
                                                                }
                                                            )}
                                                        >
                                                            <ServiceCard
                                                                name={item.name}
                                                                img={
                                                                    images[
                                                                        item
                                                                            .unique_key
                                                                    ]
                                                                }
                                                                description={
                                                                    item.description
                                                                }
                                                                uniqueKey={
                                                                    item.unique_key
                                                                }
                                                                isIssued={
                                                                    productsInfo[
                                                                        item
                                                                            .unique_key
                                                                    ]
                                                                }
                                                            />
                                                        </div>
                                                        <div
                                                            className={classNames(
                                                                cls.requiredLevelTablet,
                                                                {
                                                                    //@ts-ignore
                                                                    [cls.visibleTablet]:
                                                                        item.required_level >
                                                                            1 &&
                                                                        user.level <
                                                                            item.required_level,
                                                                }
                                                            )}
                                                        >
                                                            <Text
                                                                className={
                                                                    cls.cardTitle
                                                                }
                                                                color="#353850"
                                                                size={
                                                                    TextSize.text_16
                                                                }
                                                            >
                                                                {`Откроется на ${item.required_level} уровне`}
                                                            </Text>
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        )
                                    }
                                </div>
                            </div>
                        )}
                    </div>
                    <AppLink to="/plot" className={cls.backToGameButton}>
                        <Button
                            theme={ButtonTheme.BACK_TO_GAME}
                            icon={<PlayIcon />}
                        >
                            Продолжить сюжет
                        </Button>
                    </AppLink>
                </main>
            </Wrapper>
        </div>
    );
};
